import { useMemo } from 'react'

export const useAnalytics = () => {
  const config = useMemo(
    () => ({
      gtmId: process.env.NEXT_PUBLIC_GTM_ID,
      gaId: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
      isProduction: process.env.NODE_ENV === 'production',
      isEnabled:
        process.env.NODE_ENV === 'production' &&
        process.env.NEXT_PUBLIC_GTM_ID &&
        process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID
    }),
    []
  )

  const logAnalyticsEvent = (eventName, parameters = {}) => {
    if (config.isEnabled && typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, parameters)
    }
  }

  const logGTMEvent = (eventName, parameters = {}) => {
    if (config.isEnabled && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: eventName,
        ...parameters
      })
    }
  }

  return {
    config,
    logAnalyticsEvent,
    logGTMEvent
  }
}
